var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilesImages = function SvgFilesImages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M9.333 1.333H4a1.333 1.333 0 0 0-1.333 1.334v10.666A1.333 1.333 0 0 0 4 14.667h8a1.334 1.334 0 0 0 1.333-1.334v-8m-4-4a1.6 1.6 0 0 1 1.136.47l2.392 2.393a1.6 1.6 0 0 1 .472 1.137m-4-4v3.334a.667.667 0 0 0 .667.666h3.333m0 6-.864-.864a1.606 1.606 0 0 0-2.272 0L6 14.667M8 8a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 8 8"
  })));
};
export default SvgFilesImages;